export const CheckMarkIcon = () => {
    return <div className="custom-check-mark"></div>;
};

export const ErrorIcon = () => {
    return <div className="custom-error-icon"></div>;
};
